import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITimelineActionsProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    withTimelineContext
} from "../../context";

const TimelineActionsContent: FC<TimelinePartContentProps<ITimelineActionsProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const {
        controlHeights,
        touchTargets,
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const pointerType = usePointerType();

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlHeights,
        touchTargets,
        pointerType,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default withTimelineContext("Actions", TimelineActionsContent);
